import autoenrichReducer from "@/reducers/autoenrichReducer"
import accessReducer from "reducers/accessReducer"
import activityReducer from "reducers/activityReducer"
import classNotesReducer from "reducers/classNotesReducer"
import contentPageReducer from "reducers/contentPageReducer"
import customerReducer from "reducers/customerReducer"
import dataReducer from "reducers/dataReducer"
import donationsReducer from "reducers/donationsReducer"
import emailReducer from "reducers/emailReducer"
import jobPostsReducer from "reducers/jobPostsReducer"
import navigationReducer from "reducers/navigationReducer"
import permissionsReducer from "reducers/permissionsReducer"
import privacyReducer from "reducers/privacyReducer"
import profileReducer from "reducers/profileReducer"
import searchReducer from "reducers/searchReducer"
import tasksReducer from "reducers/tasksReducer"
import wealthReducer from "reducers/wealthReducer"
import welcomeReducer from "reducers/welcomeReducer"
// import { combineReducers } from "redux"

export const REDUCERS = {
  access: accessReducer,
  activity: activityReducer,
  classNotes: classNotesReducer,
  customer: customerReducer,
  data: dataReducer,
  donations: donationsReducer,
  email: emailReducer,
  jobPosts: jobPostsReducer,
  navigation: navigationReducer,
  permissions: permissionsReducer,
  privacy: privacyReducer,
  profile: profileReducer,
  search: searchReducer,
  tasks: tasksReducer,
  wealth: wealthReducer,
  welcome: welcomeReducer,
  contentPage: contentPageReducer,
  autoenrich: autoenrichReducer,
}

// const RootReducer = combineReducers(REDUCERS)

// export default RootReducer
